import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';
import { ValidacaoScrPesquisaComponent } from './validacao-scr-pesquisa.component';
import { ValidacaoScrDetalheComponent } from './validacao-scr-detalhe.component';

const routes: Routes = [
  {
    path: 'validacoes-scr/pesquisa',
    component: ValidacaoScrPesquisaComponent,
    canActivate: [AuthenticationGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'validacoes-scr/:id',
    component: ValidacaoScrDetalheComponent,
    canActivate: [AuthenticationGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValidacaoScrRoutingModule { }
